import React from 'react';
import {connect} from "react-redux";
import moment from 'moment';
import ScopeApi from "../../apis/ScopeApi";
import {setSmallScope} from "../../actions/scopeAction";
import Helmet from "react-helmet";

class ScopeSmall extends React.Component {

    componentDidMount() {
        const {scope, setSmallScope} = this.props;
        if(!scope.small || (scope.smallLastLoaded && moment(scope.smallLastLoaded).isBefore(moment().subtract(2, 'hour')))) {
            ScopeApi.loadSmallScope()
                .then((response) => {
                    if(response.data && response.data.success) {
                        setSmallScope(response.data.data);
                    }
                });
        }
    }

    render() {
        const {scope} = this.props;
        return scope.small && scope.small.backendName ? (
            <Helmet>
                <title>
                    {scope.small.backendName}
                </title>
            </Helmet>
        ) : null
    }
}

const mapStateToProps = state => ({
    scope: state.scope
});

export default connect(mapStateToProps, {
    setSmallScope
})(ScopeSmall);
